import { useLocation } from "react-router";
import { useMemo } from "react";
import { Breadcrumb, BreadcrumbItem } from "reactstrap";
import { Link } from "react-router-dom";
import styled from "styled-components";
import routes from "../../routes";
import stringUtils from "../../_services/string-utils";

const removeLastSegment = (pathname) => {
    let splits = pathname.split("/");
    splits.pop();
    return splits.join("/");
};

const Breadcrumbs = () => {
    const location = useLocation();

    const uniqueRoutes = useMemo(() => {
        return [
            ...new Set(
                routes.map((route) => {
                    return {
                        name: route.name,
                        path: route.path.split(":")[0],
                    };
                })
            ),
        ];
    }, []);

    const breadcrumbItems = useMemo(() => {
        let items = [];
        for (
            let pathname = location.pathname;
            !stringUtils.isBlank(pathname) && !stringUtils.equals(pathname, "/");
            pathname = removeLastSegment(pathname)
        ) {
            // First find an exact match
            let index = uniqueRoutes.findIndex((route) => {
                return stringUtils.equals(pathname, route.path);
            });

            // if none is there we use the first matching one
            /*
            if (index < 0) {
                index = uniqueRoutes.findIndex((route) => {
                    if (stringUtils.containsIgnoreCase(pathname, route.path)) {
                        console.log(pathname + " contains " + route.path);
                    }
                    return stringUtils.containsIgnoreCase(pathname, route.path);
                });
            }*/

            if (index > -1) {
                items = [routes[index], ...items];
            }
        }

        return [{ name: "Home", path: "/" }, ...items];
    }, [uniqueRoutes, location.pathname]);

    if (breadcrumbItems.length > 1) {
        return (
            <BreadcrumbWrapper>
                <CustomBreadcrumb className="light-subtle">
                    {breadcrumbItems.map((item, index) => {
                        return (
                            <BreadcrumbItem key={index}>
                                <Link to={item.path}>{item.name}</Link>
                            </BreadcrumbItem>
                        );
                    })}
                    {/*
                    <BreadcrumbItem>
                    <Link to="/test1">Test1</Link>
                </BreadcrumbItem>
                <BreadcrumbItem>
                    <Link to="/test2">Test2</Link>
                </BreadcrumbItem>
                <BreadcrumbItem>Test3</BreadcrumbItem>
                     */}
                </CustomBreadcrumb>
            </BreadcrumbWrapper>
        );
    } else {
        return <EmptyBreadcrumb />;
    }
};

export default Breadcrumbs;

const BreadcrumbWrapper = styled.div`
    height: 2.75rem;
    margin-bottom: 1.5rem;
`;

const EmptyBreadcrumb = styled.div`
    display: flex;
    flex-wrap: wrap;
    padding: 0.75rem 1rem !important;
    margin-bottom: 1.5rem;
    list-style: none;
    min-height: 2.75rem !important;

    & > .breadcrumb {
        margin-bottom: 0 !important;
    }

    & > .breadcrumb-item {
        height: 21px;
    }
`;

const CustomBreadcrumb = styled(Breadcrumb)`
    display: flex;
    flex-wrap: wrap;
    padding: 0.75rem 1rem !important;
    margin-bottom: 1.5rem;
    list-style: none;
    background-color: #fff;
    border-bottom: 1px solid var(--bs-dark-bg-subtle);
    min-height: 2.75rem !important;

    & > .breadcrumb {
        margin-bottom: 0 !important;
    }

    & > .breadcrumb-item {
        height: 21px;
    }
`;
